/* SessionLastUpdated.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@atlaskit/primitives/compiled/box';
const styles = {
  lastUpdated: "_3YEZNOdnbC"
};
export type SessionLastUpdatedProps = {
  /** Time of the latest state change, in epoch milliseconds. */
  lastStateChangeAt?: number;
  /** Preformatted content for consumers that do not have a raw timestamp. */
  lastUpdated?: ReactNode;
  testId?: string;
};
const COMPACT_TIME_UNITS: ReadonlyArray<readonly [suffix: string, milliseconds: number]> = [['y', 31_536_000_000], ['w', 604_800_000], ['d', 86_400_000], ['h', 3_600_000], ['m', 60_000]];
const RelativeSessionTime = ({
  timestamp
}: {
  timestamp: number;
}): React.JSX.Element => {
  const {
    formatNumber
  } = useIntl();
  const now = React.useMemo(() => Date.now(), []);
  const elapsed = Math.abs(now - timestamp);
  const [suffix, milliseconds] = COMPACT_TIME_UNITS.find(([, unitMilliseconds]) => elapsed >= unitMilliseconds) ?? ['m', 60_000];
  const value = Math.max(1, Math.floor(elapsed / milliseconds));
  return <>
			{formatNumber(value)}
			{suffix}
		</>;
};

/** Renders a raw session timestamp as compact elapsed time. */
export const SessionLastUpdated = ({
  lastStateChangeAt,
  lastUpdated,
  testId
}: SessionLastUpdatedProps): React.JSX.Element | null => {
  const content = lastStateChangeAt != null ? <RelativeSessionTime timestamp={lastStateChangeAt} /> : lastUpdated;
  if (content === undefined || content === null || content === false) {
    return null;
  }
  return <Box as="span" xcss={styles.lastUpdated} testId={testId}>
			{content}
		</Box>;
};